import { combineReducers, createReducer, on } from '@ngrx/store';
import { addAllClientAccounts, addAllPortfolios, decrementCurrentWizardStep, incrementCurrentWizardStep, resetAccountResultsLoaded, resetCurrentWizardStep, resetSelectAllClientAccounts, resetSelectAllPortfolios, resetSelectedAccounts, resetSelectedIRebalPortfolios, selectAccount, selectClient, selectIRebalPortfolio, setAccountResultsLoaded, setImportType, setPortfolioImportType, setSearchType, toggleSelectAllClientAccounts, toggleSelectAllPortfolios, } from './import-holdings.actions';
import { SCHWAB_CLIENT } from 'IntegrationsApp/ts/constants';
import { CLIENT_PORTFOLIO } from 'ModelPortfolioApp/ts/shared/constants';
export const currentWizardStepIndex = createReducer(0, on(incrementCurrentWizardStep, (state) => {
    return state + 1;
}), on(decrementCurrentWizardStep, (state) => {
    return state - 1;
}), on(resetCurrentWizardStep, () => {
    return 0;
}));
export const searchType = createReducer(SCHWAB_CLIENT, on(setSearchType, (state, { searchType: newSearchType }) => {
    return newSearchType;
}));
export const portfolioImportType = createReducer(CLIENT_PORTFOLIO, on(setPortfolioImportType, (state, { newPortfolioImportType }) => {
    return newPortfolioImportType;
}));
export const selectedClient = createReducer(null, on(selectClient, (state, { selectedClient: newClient }) => {
    return newClient;
}));
export const selectedAccounts = createReducer([], on(selectAccount, (state, { selectedAccountId: newAccountId }) => {
    if (state.map((account) => account.id).includes(newAccountId)) {
        return state.filter((account) => account.id !== newAccountId);
    }
    return [...state, { id: newAccountId, importAsSingleHolding: false }];
}), on(setImportType, (state, { id, importAsSingleHolding }) => {
    if (state.map((account) => account.id).includes(id)) {
        return state.map((account) => {
            if (account.id === id) {
                return { ...account, importAsSingleHolding };
            }
            return account;
        });
    }
    return [...state, { id, importAsSingleHolding }];
}), on(addAllClientAccounts, (state, { accounts }) => {
    return accounts.map((account) => {
        return { id: account.subAccountId, importAsSingleHolding: false };
    });
}), on(resetSelectedAccounts, () => {
    return [];
}));
export const selectedPortfolios = createReducer([], on(selectIRebalPortfolio, (state, { selectedPortfolioId: newAccountId }) => {
    if (state.map((account) => account.id).includes(newAccountId)) {
        return state.filter((account) => account.id !== newAccountId);
    }
    return [...state, { id: newAccountId, importAsSingleHolding: false }];
}), on(setImportType, (state, { id, importAsSingleHolding }) => {
    if (state.map((account) => account.id).includes(id)) {
        return state.map((account) => {
            if (account.id === id) {
                return { ...account, importAsSingleHolding };
            }
            return account;
        });
    }
    return [...state, { id, importAsSingleHolding }];
}), on(addAllPortfolios, (state, { portfolios }) => {
    return portfolios.map((portfolio) => {
        return { id: portfolio.id, importAsSingleHolding: false };
    });
}), on(resetSelectedIRebalPortfolios, () => {
    return [];
}));
export const selectAllClientAccounts = createReducer(false, on(toggleSelectAllClientAccounts, (state) => {
    return !state;
}), on(resetSelectAllClientAccounts, () => {
    return false;
}));
export const selectAllPortfolios = createReducer(false, on(toggleSelectAllPortfolios, (state) => {
    return !state;
}), on(resetSelectAllPortfolios, () => {
    return false;
}));
export const accountResultsLoaded = createReducer(false, on(setAccountResultsLoaded, (state, action) => {
    return action.loaded;
}), on(resetAccountResultsLoaded, () => {
    return false;
}));
export const schwabImportHoldings = combineReducers({
    currentWizardStepIndex,
    searchType,
    selectedClient,
    selectedAccounts,
    selectedPortfolios,
    selectAllClientAccounts,
    selectAllPortfolios,
    portfolioImportType,
    accountResultsLoaded,
});
